export default __webpack_public_path__ + "static/media/Icon awesome-facebook-f.560aaa61.svg";